import { render } from "./F2FormInputGroup.vue?vue&type=template&id=fc265200&ts=true"
import script from "./F2FormInputGroup.vue?vue&type=script&lang=ts"
export * from "./F2FormInputGroup.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__